import BrandLogo from '../../components/BrandLogo';

export default function AuthShell({ icon, title, subtitle, children }) {
  return (
    <div className="flex min-h-full items-center justify-center bg-slate-50 px-4 py-12">
      <div className="w-full max-w-md">
        <div className="rounded-2xl border border-slate-100 bg-slate-100 p-8 shadow-md">
          <div className="mb-6 flex flex-col items-center text-center">
            <BrandLogo className="mb-5 h-10 w-auto max-w-full" />
            <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-xl bg-brand-50">
              {icon}
            </div>
            <h1 className="text-2xl font-semibold text-slate-800">{title}</h1>
            {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
